import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import ModalSpecial from "../Layout/Modals/ModalSpecial";
import Spinner from "../common/Spinner";
import { Checkbox, TimePicker } from "antd";
import {
  ButtonSecondary,
  DebounceSelect,
  Error,
  InputSwitchComponent,
  Label,
  SelectCountry,
  SelectInput,
  SelectWeekDays,
  Switch,
  TextInput,
} from "../globals";
import { errorHandler, getDateFormat } from "../../helpers/Utils";
import styled from "styled-components";
import RangePickerComp from "../common/RangePickerComp";
import Axios from "axios";
import { putItemRule } from "../../redux/Actions/imum_rules_action";
import moment from "moment";
import AntdConfirm from "../../helpers/AntdConfirm";
import { BlockSquare } from "../common/StyledComponents";
import { FaLock } from "react-icons/fa";

function ModalImumRules({ modalFunc, id }) {
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const creating = id == 0;
  const hasSetData = React.useRef(false);
  const hasSetSupplierData = React.useRef(false);

  const { loading, value, setValue } = useFetch(
    `/api/v1/${window.identifier}/imum_rules/${creating ? "new" : id}`
  );
  const { value: value_imum_shops } = useFetch(
    `/api/v1/${window.identifier}/imums/imum_shops`
  );
  // const { value: imum_rules } = useFetch(
  //   `/api/v1/${window.identifier}/imum_rules?page=1&per_page=25`
  // );

  React.useEffect(() => {
    const fetchDependentRuleDetails = async () => {
      if (value && value.dependent_rule_ids && !hasSetData.current) {
        const ids = value.dependent_rule_ids
          .map((id) => `q[id_in][]=${id}`)
          .join("&");
        if (ids.length === 0) {
          hasSetData.current = true;
          return;
        }
        const { data } = await Axios.get(
          `/api/v1/${window.identifier}/imum_rules?${ids}`
        );

        const dependentRuleDetails = data?.data?.map((rule) => ({
          value: rule.id,
          label: rule.title,
        }));

        setValue((prev) => ({
          ...prev,
          dependent_rule_ids: dependentRuleDetails,
        }));

        hasSetData.current = true;
      }
    };

    const fetchSupplierRulesDetails = async () => {
      if (value && value.parameters?.supplier_rules && Array.isArray(value.parameters.supplier_rules) && !hasSetSupplierData.current) {
        const updatedRules = await Promise.all(
          value.parameters.supplier_rules.map(async (rule) => {
            if (rule.suppliers && rule.suppliers.length > 0 && typeof rule.suppliers[0] === 'number') {
              const ids = rule.suppliers
                .map((id) => `q[id_in][]=${id}`)
                .join("&");

              try {
                const { data } = await Axios.get(`/api/v1/suppliers?${ids}`);
                const supplierDetails = data?.data?.map((supplier) => ({
                  value: supplier.id,
                  label: supplier.name,
                }));

                return {
                  ...rule,
                  suppliers: supplierDetails,
                  current_suppliers: supplierDetails,
                };
              } catch (err) {
                console.error("Error fetching supplier details:", err);
                return rule;
              }
            }
            return rule;
          })
        );

        setValue((prev) => ({
          ...prev,
          parameters: {
            ...prev.parameters,
            supplier_rules: updatedRules,
          },
        }));

        hasSetSupplierData.current = true;
      }
    };

    if (!loading && value) {
      fetchDependentRuleDetails();
      fetchSupplierRulesDetails();
    }
  }, [loading, value]);

  useEffect(() => {
    if (!loading && value && !value.id && !value.countries) {
      setValue((prev) => ({
        ...prev,
        countries: window.identifier == "technorama" ? ["LT"] : [],
        bb_shop: window.identifier == "technorama" ? "tch" : "bb",
      }));
    }
  }, [loading]);

  if (loading) {
    return (
      <ModalSpecial
        style={{
          width: 500,
        }}
        onClose={() => modalFunc(false)}
      >
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinner />
        </div>
      </ModalSpecial>
    );
  }

  const onChange = (e) => {
    const { name, value } = e.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeParameters = (e) => {
    const { name, value } = e.target;
    setValue((prev) => ({
      ...prev,
      parameters: prev.parameters
        ? {
          ...prev.parameters,
          [name]: value,
        }
        : {
          [name]: value,
        },
    }));
  };

  const onChangeLetPrice = (val) => {
    let custom_value = value?.parameters?.let_prices || "";
    let val_return = "";
    console.log({ custom_value, val });
    if (custom_value == "all") {
      val_return = val == "lower" ? "raise" : "lower";
    } else if (val == custom_value) {
      val_return = "";
    } else {
      if (custom_value == "") {
        val_return = val;
      } else if (custom_value !== val) {
        val_return = "all";
      }
    }
    onChangeParameters({
      target: {
        name: "let_prices",
        value: val_return,
      },
    });
  };

  const fetchOptions = async (value, type = "family") => {
    try {
      let api_url = `/api/v1/imum_categories?q=${value}`;
      if (type == "brand")
        api_url = `/api/v1/brands?q[title_i_cont_any]=${value}`;
      if (type == "tag")
        api_url = `/api/v1/${window.identifier}/imum_product_tags?q[title_i_cont_any]=${value}`;
      if (type == "dependent_rule_ids")
        api_url = `/api/v1/${window.identifier}/imum_rules?q[id_not_eq]=${id}&q[title_i_cont_any]=${value}`;
      if (type == "supplier")
        api_url = `/api/v1/suppliers/all?q[name_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);

      const items = (type === "dependent_rule_ids" || type == "supplier") ? data.data : data;

      const mapData = items.map((e) => {
        return {
          ...e,
          value: e.id,
          label:
            type == "tag" ? (
              <div className="d-flex align-items-center cursor-pointer">
                <BlockSquare color={e.color} />
                <div
                  className={`ml-1 text-xs`}
                  style={{
                    color: "#737373",
                  }}
                >
                  {e.title}
                </div>
              </div>
            ) : (
              e.title || e.name
            ),
        };
      });
      console.log(mapData, "mapData");
      return mapData;
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };
  console.log(fetchOptions("", "dependent_rule_ids"));

  const onSave = async () => {
    try {
      setErrors({});
      console.log(value, "value before newValue");
      const newValue = { ...value };

      if (
        Array.isArray(newValue.dependent_rule_ids) &&
        newValue.dependent_rule_ids.length > 0 &&
        typeof newValue.dependent_rule_ids[0] === "object"
      ) {
        newValue.dependent_rule_ids = newValue.dependent_rule_ids.map(
          (item) => item.value
        );
      }

      if (newValue.parameters?.supplier_rules && Array.isArray(newValue.parameters.supplier_rules)) {
        newValue.parameters.supplier_rules = newValue.parameters.supplier_rules.map((rule) => {
          const cleanedRule = { ...rule };

          if (Array.isArray(cleanedRule.suppliers) && cleanedRule.suppliers.length > 0) {
            if (typeof cleanedRule.suppliers[0] === "object") {
              cleanedRule.suppliers = cleanedRule.suppliers.map((s) => s.value || s.id);
            }
          }

          delete cleanedRule.current_suppliers;
          delete cleanedRule.id;

          return cleanedRule;
        });
      }

      console.log(newValue, "newValue");
      const { success, errors } = await dispatch(putItemRule(newValue));
      console.log({ success, errors });
      if (success) {
        modalFunc(false);
      } else {
        const normalizedErrors = Object.entries(errors || {}).reduce(
          (acc, [key, value]) => {
            acc[key] = Array.isArray(value) ? value.join(", ") : value;
            return acc;
          },
          {}
        );

        if (normalizedErrors.schedule_time_2) {
          normalizedErrors.schedule_time = normalizedErrors.schedule_time
            ? `${normalizedErrors.schedule_time} ${normalizedErrors.schedule_time_2}`
            : normalizedErrors.schedule_time_2;
        }

        setErrors(normalizedErrors);
      }
    } catch (e) {
      console.log("ERROR: " + e);
    }
  };

  console.log("Wtf: ", errors);

  return (
    <ModalSpecial
      style={{
        width: 500,
      }}
      text={creating ? "Create rule" : "Edit rule"}
      onClose={() => {
        AntdConfirm({
          title: "Are you sure want to close modal?",
          content: "",
          onOk: () => {
            return modalFunc(false);
          },
        });
      }}
    >
      <div>
        <TextInput
          text="Rule title"
          name="title"
          required={true}
          value={value.title}
          onChange={onChange}
          warning={errors.title}
        />
        <div className="my-2" />

        <Label>
          <span className="font-bold">Assign by</span>
        </Label>

        <DebounceSelect
          mode="multiple"
          labelInValue={false}
          label="Categories"
          showSearch={true}
          value={value.categories}
          placeholder={"Type to search"}
          fetchOptions={fetchOptions}
          options={value.current_categories}
          onChange={(value) =>
            onChange({
              target: { name: "categories", value },
            })
          }
          style={{
            width: "100%",
          }}
        />
        <Label>Brands</Label>
        <div
          className="p-2"
          style={{
            backgroundColor: "#F5F5F5",
            border: "1px solid #EFEFEF",
            borderRadius: 1,
          }}
        >
          <div className="text-xs">Include</div>
          <DebounceSelect
            mode="multiple"
            labelInValue={false}
            showSearch={true}
            value={value.brands}
            placeholder={"Type to search"}
            fetchOptions={(val) => fetchOptions(val, "brand")}
            options={value.current_brands}
            onChange={(value) =>
              onChange({
                target: { name: "brands", value },
              })
            }
            style={{
              width: "100%",
            }}
          />
          <div className="text-xs">Exclude</div>
          <DebounceSelect
            mode="multiple"
            labelInValue={false}
            showSearch={true}
            value={value.exclude_brands}
            placeholder={"Type to search"}
            fetchOptions={(val) => fetchOptions(val, "brand")}
            options={value.current_exclude_brands}
            onChange={(value) =>
              onChange({
                target: { name: "exclude_brands", value },
              })
            }
            style={{
              width: "100%",
            }}
          />
        </div>

        <Label>Tags</Label>
        <div
          className="p-2"
          style={{
            backgroundColor: "#F5F5F5",
            border: "1px solid #EFEFEF",
            borderRadius: 1,
          }}
        >
          <div className="text-xs">Include</div>
          <DebounceSelect
            className="select-light-blue"
            mode="multiple"
            labelInValue={false}
            showSearch={true}
            value={value.tags}
            placeholder={"Type to search"}
            fetchOptions={(val) => fetchOptions(val, "tag")}
            options={value.current_tags}
            onChange={(value) =>
              onChange({
                target: { name: "tags", value },
              })
            }
            style={{
              width: "100%",
            }}
          />
          <div className="text-xs">Exclude</div>
          <DebounceSelect
            className="select-light-red"
            mode="multiple"
            labelInValue={false}
            showSearch={true}
            value={value.exclude_tags}
            placeholder={"Type to search"}
            fetchOptions={(val) => fetchOptions(val, "tag")}
            options={value.current_exclude_tags}
            onChange={(value) =>
              onChange({
                target: { name: "exclude_tags", value },
              })
            }
            style={{
              width: "100%",
            }}
          />
        </div>

        <Label required={true} error={errors.let_prices}>
          Let prices
        </Label>
        {[
          {
            label: "Raise",
            value: "raise",
          },
          {
            label: "Lower",
            value: "lower",
          },
        ].map((d) => {
          const active = [d.value, "all"].includes(
            value?.parameters?.let_prices
          );
          return (
            <ApplyActionItemStyled
              key={d.value}
              className="mb-2 cursor-pointer"
              active={active}
              onClick={() => onChangeLetPrice(d.value)}
            >
              <div className={`pl-3 py-2 text-xs text-font font-semi-bold`}>
                <Checkbox
                  checked={active}
                  onChange={() => onChangeLetPrice(d.value)}
                />
                <span
                  className={`pl-2 text-xs text-font font-semi-bold `}
                  style={{
                    color: active ? "#03b0f7" : "#6C6C6C",
                  }}
                >
                  {d.label}
                </span>
              </div>
            </ApplyActionItemStyled>
          );
        })}
        {window.identifier !== "technorama" && (
          <>
            <div className="my-2" />
            <SelectCountry
              type={"switch"}
              value={value.countries}
              onChange={onChange}
              error={errors.countries}
            />
          </>
        )}

        <div className="my-2" />
        {/* <SelectInput
          mode="multiple"
          label="Excluded competitors"
          options={value_imum_shops?.data?.map((value) => ({
            label: value,
            value,
          }))}
          value={value.shops || undefined}
          dropdownMatchSelectWidth={false}
          onChange={(value) => onChange({ target: { name: "shops", value } })}
          // error={errors.competitor_ids}
        /> */}
        <Label>Competitors</Label>
        <div
          className="p-2"
          style={{
            backgroundColor: "#F5F5F5",
            border: "1px solid #EFEFEF",
            borderRadius: 1,
          }}
        >
          <div className="text-xs">Include</div>
          <SelectInput
            mode="multiple"
            options={value_imum_shops?.data?.map((shop) => ({
              label: shop,
              value: shop,
            }))}
            value={value.included_shops || undefined}
            disabled={value?.shops?.length > 0 ? true : false}
            dropdownMatchSelectWidth={false}
            onChange={(value) =>
              onChange({ target: { name: "included_shops", value } })
            }
          />
          <div className="text-xs">Exclude</div>
          <SelectInput
            mode="multiple"
            options={value_imum_shops?.data?.map((shop) => ({
              label: shop,
              value: shop,
            }))}
            value={value.shops || undefined}
            dropdownMatchSelectWidth={false}
            disabled={value?.included_shops?.length > 0 ? true : false}
            onChange={(value) => onChange({ target: { name: "shops", value } })}
          />
        </div>

        <div className="my-2"></div>
        <DebounceSelect
          mode="multiple"
          labelInValue={false}
          label="Run after selected rule"
          showSearch={true}
          value={value.dependent_rule_ids}
          placeholder={"Type to search"}
          fetchOptions={(val) => fetchOptions(val, "dependent_rule_ids")}
          onChange={(value) =>
            onChange({
              target: { name: "dependent_rule_ids", value },
            })
          }
          style={{
            width: "100%",
          }}
        />
        {/* Priority product */}
        <Switch
          label="Priority product"
          checked={value.priority_product}
          onChange={() =>
            onChange({
              target: {
                name: "priority_product",
                value: !value.priority_product,
              },
            })
          }
        />
        {/* Supplier cost price logic */}
        <Switch
          label="Use supplier cost price"
          checked={value.parameters?.use_supplier_cost}
          onChange={() =>
            onChangeParameters({
              target: {
                name: "use_supplier_cost",
                value: !value.parameters?.use_supplier_cost,
              },
            })
          }
          text={value.parameters?.use_supplier_cost ? "Yes" : "No"}
        />

        {value.parameters?.use_supplier_cost && (
          <>
            <Label>Supplier Rules</Label>
            {(value.parameters?.supplier_rules || [{ id: Date.now() }]).map((rule, index) => (
              <div
                key={rule.id || index}
                className="p-3 mb-3"
                style={{
                  backgroundColor: "#F5F5F5",
                  border: "1px solid #EFEFEF",
                  borderRadius: 4,
                  position: "relative",
                }}
              >
                {(value.parameters?.supplier_rules || []).length > 1 && (
                  <button
                    type="button"
                    onClick={() => {
                      const newRules = [...(value.parameters?.supplier_rules || [])];
                      newRules.splice(index, 1);
                      onChangeParameters({
                        target: {
                          name: "supplier_rules",
                          value: newRules,
                        },
                      });
                    }}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      background: "#ff4d4f",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "4px 8px",
                      cursor: "pointer",
                      fontSize: 12,
                    }}
                  >
                    X
                  </button>
                )}

                <div className="text-xs font-bold mb-2">Rule #{index + 1}</div>

                <DebounceSelect
                  mode="multiple"
                  labelInValue={false}
                  label="Suppliers"
                  showSearch={true}
                  value={rule.suppliers}
                  placeholder={"Type to search suppliers"}
                  fetchOptions={(val) => fetchOptions(val, "supplier")}
                  options={rule.current_suppliers || []}
                  onChange={(suppliers) => {
                    const newRules = [...(value.parameters?.supplier_rules || [{ id: Date.now() }])];
                    newRules[index] = { ...newRules[index], suppliers };
                    onChangeParameters({
                      target: {
                        name: "supplier_rules",
                        value: newRules,
                      },
                    });
                  }}
                  style={{
                    width: "100%",
                  }}
                />

                <Label>Supplier cost value adjust</Label>
                <div className="d-flex justify-content-between">
                  <div style={{ width: "60%" }}>
                    <TextInput
                      name="supplier_cost_value"
                      type="number"
                      suffix={rule.supplier_cost_type || "%"}
                      value={rule.supplier_cost_value}
                      onChange={(e) => {
                        const newRules = [...(value.parameters?.supplier_rules || [{ id: Date.now() }])];
                        newRules[index] = { ...newRules[index], supplier_cost_value: e.target.value };
                        onChangeParameters({
                          target: {
                            name: "supplier_rules",
                            value: newRules,
                          },
                        });
                      }}
                    />
                  </div>
                  <div style={{ width: "30%" }}>
                    <InputSwitchComponent
                      name="supplier_cost_type"
                      options={[
                        { label: "%", value: "%" },
                        { label: "€", value: "€" },
                      ]}
                      value={rule.supplier_cost_type || "%"}
                      onChange={(e) => {
                        const newRules = [...(value.parameters?.supplier_rules || [{ id: Date.now() }])];
                        newRules[index] = { ...newRules[index], supplier_cost_type: e.target.value };
                        onChangeParameters({
                          target: {
                            name: "supplier_rules",
                            value: newRules,
                          },
                        });
                      }}
                    />
                  </div>
                </div>

                <Label>Supplier other costs</Label>
                <div className="d-flex justify-content-between">
                  <div style={{ width: "60%" }}>
                    <TextInput
                      name="supplier_other_value"
                      type="number"
                      suffix={rule.supplier_other_type || "€"}
                      value={rule.supplier_other_value}
                      onChange={(e) => {
                        const newRules = [...(value.parameters?.supplier_rules || [{ id: Date.now() }])];
                        newRules[index] = { ...newRules[index], supplier_other_value: e.target.value };
                        onChangeParameters({
                          target: {
                            name: "supplier_rules",
                            value: newRules,
                          },
                        });
                      }}
                    />
                  </div>
                  <div style={{ width: "30%" }}>
                    <InputSwitchComponent
                      name="supplier_other_type"
                      options={[
                        { label: "%", value: "%" },
                        { label: "€", value: "€" },
                      ]}
                      value={rule.supplier_other_type || "€"}
                      onChange={(e) => {
                        const newRules = [...(value.parameters?.supplier_rules || [{ id: Date.now() }])];
                        newRules[index] = { ...newRules[index], supplier_other_type: e.target.value };
                        onChangeParameters({
                          target: {
                            name: "supplier_rules",
                            value: newRules,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}

            <button
              type="button"
              onClick={() => {
                const newRules = [
                  ...(value.parameters?.supplier_rules || [{ id: Date.now() }]),
                  {
                    id: Date.now(),
                    suppliers: [],
                    supplier_cost_value: "",
                    supplier_cost_type: "%",
                    supplier_other_value: "",
                    supplier_other_type: "€",
                  },
                ];
                onChangeParameters({
                  target: {
                    name: "supplier_rules",
                    value: newRules,
                  },
                });
              }}
              style={{
                background: "#03B0F7",
                color: "white",
                border: "none",
                borderRadius: 4,
                padding: "8px 16px",
                cursor: "pointer",
                width: "100%",
                marginBottom: 16,
              }}
            >
              Add Supplier Rule
            </button>
          </>
        )}
        {/* No price changes */}
        <Switch
          label="No price changes"
          checked={value.parameters?.no_price_changes}
          onChange={() =>
            onChangeParameters({
              target: {
                name: "no_price_changes",
                value: !value.parameters?.no_price_changes,
              },
            })
          }
          text={value.parameters?.no_price_changes ? "Yes" : "No"}
        />

        {!value.parameters?.no_price_changes && (
          <React.Fragment>
            <Switch
              label="Ignore the prime cost"
              checked={value.parameters?.ignore_the_prime_cost}
              onChange={() =>
                onChangeParameters({
                  target: {
                    name: "ignore_the_prime_cost",
                    value: !value.parameters?.ignore_the_prime_cost,
                  },
                })
              }
              text={value.parameters?.ignore_the_prime_cost ? "Yes" : "No"}
            />
            {/* <div className="my-2"></div> */}
            {!value.parameters?.ignore_the_prime_cost && (
              <div
                className="p-2 mb-1"
                style={{
                  backgroundColor: "#F5F5F5",
                  border: "1px solid #EFEFEF",
                  borderRadius: 4,
                  position: "relative",
                }}
              >
                <Label>Price cannot be less than the cost price</Label>
                <div className="d-flex justify-content-between">
                  <div style={{ width: "60%" }}>
                    <TextInput
                      suffix={value.parameters?.price_cost_type}
                      name="price_cost_value"
                      type="number"
                      value={value.parameters?.price_cost_value}
                      onChange={onChangeParameters}
                    />
                  </div>
                  {/* <Label>Price cannot be less than the cost price</Label>
                <div className="d-flex justify-content-between">
                  <div
                    style={{
                      width: "30%",
                    }}
                  >
                    <InputSwitchComponent
                      name="price_cost_type"
                      options={[
                        {
                          label: "+",
                          value: "+",
                        },
                        {
                          label: "-",
                          value: "-",
                        },
                      ]}
                      value={value.parameters?.price_cost_type}
                      onChange={onChangeParameters}
                    />
                  </div>
                  <div style={{ width: "60%" }}>
                    <TextInput
                      name="price_cost_value"
                      type="number"
                      suffix="%"
                      value={value.parameters?.price_cost_value}
                      onChange={onChangeParameters}
                    />
                  </div>
                </div> */}

                  <div
                    style={{
                      width: "30%",
                    }}
                  >
                    <InputSwitchComponent
                      name="price_cost_type"
                      options={[
                        {
                          label: "%",
                          value: "%",
                        },
                        {
                          label: "€",
                          value: "€",
                        },
                      ]}
                      value={value.parameters?.price_cost_type}
                      onChange={onChangeParameters}
                    />
                  </div>
                </div>
                <Label>and not less than:</Label>      
                <div className="d-flex justify-content-between">
                  <div style={{ width: "60%" }}>
                    <TextInput
                      suffix={value.parameters?.price_cost_type_2}
                      name="price_cost_value_2"
                      type="number"
                      value={value.parameters?.price_cost_value_2}
                      onChange={onChangeParameters}
                    />
                  </div>
                  <div
                    style={{
                      width: "30%",
                    }}
                  >
                    <InputSwitchComponent
                      name="price_cost_type_2"
                      options={[
                        {
                          label: "%",
                          value: "%",
                        },
                        {
                          label: "€",
                          value: "€",
                        },
                      ]}
                      value={value.parameters?.price_cost_type_2}
                      onChange={onChangeParameters}
                    />
                  </div>
                </div>
              </div>
            )}
            <Label>Price adjusment on cheapest competitor price</Label>
            <div className="d-flex justify-content-between">
              <div style={{ width: "60%" }}>
                <TextInput
                  name="cheapest_competitor_value"
                  type="number"
                  suffix={value.parameters?.cheapest_competitor_type}
                  value={value.parameters?.cheapest_competitor_value}
                  onChange={onChangeParameters}
                />
              </div>
              <div
                style={{
                  width: "30%",
                }}
              >
                <InputSwitchComponent
                  name="cheapest_competitor_type"
                  options={[
                    {
                      label: "%",
                      value: "%",
                    },
                    {
                      label: "€",
                      value: "€",
                    },
                  ]}
                  value={value.parameters?.cheapest_competitor_type}
                  onChange={onChangeParameters}
                />
              </div>
            </div>

            <div className="my-2"></div>
          </React.Fragment>
        )}
        <Label
          required={true}
          error={errors.schedule_days || errors.schedule_time}
        >
          Schedule
        </Label>
        <SelectWeekDays
          value={value.schedule_days}
          onChange={onChange}
          error={errors.schedule_days}
        />
        <Error value={errors.schedule_days} />
        <TimePicker
          className={`w-50 mt-2 ${errors.schedule_time ? "error_border" : ""}`}
          minuteStep={5}
          showTime={{ defaultValue: moment("00:00", "HH:mm") }}
          format={"HH:mm"}
          value={
            value.schedule_time
              ? getDateFormat(
                value.schedule_time.length == 5
                  ? moment(value.schedule_time, "HH:mm")
                  : value.schedule_time
              )
              : null
          }
          onChange={(value) => {
            onChange({
              target: {
                name: "schedule_time",
                value: value.toISOString(),
              },
            });
          }}
        />
        <TimePicker
          className={`w-50 mt-2 ${errors.schedule_time_2 ? "error_border" : ""
            }`}
          minuteStep={5}
          showTime={{ defaultValue: moment("00:00", "HH:mm") }}
          format={"HH:mm"}
          value={
            value.schedule_time_2
              ? getDateFormat(
                value.schedule_time_2.length == 5
                  ? moment(value.schedule_time_2, "HH:mm")
                  : value.schedule_time_2
              )
              : null
          }
          onChange={(value) => {
            onChange({
              target: {
                name: "schedule_time_2",
                value: value ? value.toISOString() : null,
              },
            });
          }}
          allowClear={true}
        />
        <Error value={errors.schedule_time} />
        <div className="my-2"></div>

        <RangePickerComp
          renderExtraFooter={() => (
            <div className="d-flex align-items-center justify-content-center">
              {!!value.valid_from && (
                <div
                  className="text-primary py-2 cursor-pointer"
                  onClick={() => {
                    setValue((prev) => ({
                      ...prev,
                      valid_to: "",
                    }));
                  }}
                >
                  Do not set end date
                </div>
              )}
            </div>
          )}
          style={{
            width: "100%",
          }}
          label="Period"
          required={true}
          placeholder={["Start date", "End date"]}
          disabledDate={() => { }}
          value={
            value.valid_from
              ? [getDateFormat(value.valid_from), getDateFormat(value.valid_to)]
              : ["", ""]
          }
          onCalendarChange={(_, value) => {
            setValue((prev) => ({
              ...prev,
              valid_from: value[0],
              valid_to: value[1],
            }));
          }}
          warning={errors.valid_from}
        />
        <div className="my-2" />
        <Switch
          label="Disable channel price scope"
          checked={value.disable_channel_price_scope}
          onChange={() =>
            onChange({
              target: {
                name: "disable_channel_price_scope",
                value: !value.disable_channel_price_scope,
              },
            })
          }
        />
        <div className="my-2" />
        <Switch
          label="Status"
          checked={value.active}
          onChange={() =>
            onChange({ target: { name: "active", value: !value.active } })
          }
        />
        <div className="my-2" />
        <Switch
          label="Priority"
          checked={value.priority}
          onChange={() =>
            onChange({ target: { name: "priority", value: !value.priority } })
          }
        />
        <div className="my-2" />
        <ButtonSecondary onClick={() => onSave()}>
          {creating ? "Create" : "Update rule"}
        </ButtonSecondary>
      </div>
    </ModalSpecial>
  );
}

export default ModalImumRules;

const ApplyActionItemStyled = styled.div`
  background: ${(props) => (props.active ? "#edf9fe" : "#fcfcfc")};
  border: 1px solid ${(props) => (props.active ? "#03B0F7" : "#d9d9d9")};
  border-radius: 4px;
`;
